import { compose } from 'recompose';

import VariantEdit from './VariantEdit';

const enhance = compose();

export default enhance(VariantEdit);
